import React, { useEffect, useState, useRef } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { cityListRequest, stateListRequest, countryListRequest } from '../../../redux/user/user.action'
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { addProjectRequest, addProjectRequestStatus } from '../../../redux/project/project.action'
import moment from "moment";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import PercentInputHalf from "../../../components/input/percent-input-half/percentInputHalf";
import { CurrencyLabel } from "../../../utils/CurrencyLabel";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import Modal from 'react-bootstrap/Modal';

const AddProject = props => {
    const { user, countryListSuccess, countryListError, stateListSuccess, stateListError,
        cityListSuccess, cityListError, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addProjectSuccess, addProjectError, addProjectReqStatus } = useSelector(state => state.project)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [selectedProjectStatus, setSelectedProjectStatus] = useState()
    const [selectedProjectType, setSelectedProjectType] = useState()
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const projectType = [
        { key: APP_CONSTANTS.PROJECT_TYPE.OFFLINE, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_TYPE.OFFLINE) },
        { key: APP_CONSTANTS.PROJECT_TYPE.ONLINE, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_TYPE.ONLINE) }
    ]
    const projectStatus = [
        { key: APP_CONSTANTS.PROJECT_STATUS.NEW, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.NEW) },
        { key: APP_CONSTANTS.PROJECT_STATUS.PENDING, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.PENDING) },
        { key: APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS) },
        { key: APP_CONSTANTS.PROJECT_STATUS.COMPLETE, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.COMPLETE) },
        { key: APP_CONSTANTS.PROJECT_STATUS.ON_HOLD, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.ON_HOLD) },
        { key: APP_CONSTANTS.PROJECT_STATUS.CANCELLED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.CANCELLED) },
    ]
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [isFixedAmount, setIsFixedAmount] = useState(false)
    const [isEstimatedAmount, setIsEstimatedAmount] = useState(false)
    const [amount, setAmount] = useState('')
    const [taxInformation, setTaxInformation] = useState([])
    const [taxTypeLabel, setTaxTypeLabel] = useState('')
    const [taxTypePercent, setTaxTypePercent] = useState('')
    const [estimatedAmount, setEstimatedAmount] = useState('')
    const [finalAmount, setFinalAmount] = useState('')
    const customerType = [
        { key: APP_CONSTANTS.CUSTOMER_TYPE.COMMERCIAL, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.CUSTOMER_TYPE.COMMERCIAL) },
        { key: APP_CONSTANTS.CUSTOMER_TYPE.RESIDENTIAL, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.CUSTOMER_TYPE.RESIDENTIAL) }
    ]
    const [selectedCustomerType, setSelectedCustomerType] = useState(null)
    const [customerName, setCustomerName] = useState('')
    const [customerBusinessName, setCustomerBusinessName] = useState('')
    const [contactPersonName, setContactPersonName] = useState('')
    const [contactPersonNumber, setContactPersonNumber] = useState('')
    const [contactPersonEmail, setContactPersonEmail] = useState('')
    const [address, setAddress] = useState('')
    const [addressLink, setAddressLink] = useState('')
    const [countryDropdown, setCountryDropdown] = useState();
    const [stateDropdown, setStateDropdown] = useState();
    const [cityDropdown, setCityDropdown] = useState();
    const [countryCode, setCountryCode] = useState('')
    const [imageList, setImageList] = useState([])
    const fileInputRef = useRef(null);
    const [selectedCurrency, setSelectedCurrency] = useState(null)
    const [isInvitationOpen, setIsInvitationOpen] = useState(false)
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_PROJECT, true)
            fetchBusinessList()
        }
        dispatch({ type: APP_CONSTANTS.RESET_STATE_CITY })
        setLoading(true)
        dispatch(countryListRequest())
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchStateList = (countryId) => {
        setLoading(true)
        const data = {
            countryId: countryId
        }
        dispatch(stateListRequest(data))
    }

    const fetchCityList = (countryId, stateId) => {
        setLoading(true)
        const data = {
            countryId: countryId,
            stateId: stateId
        }
        dispatch(cityListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_PROJECT) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_PROJECT, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (addProjectReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (addProjectReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addProjectError.message)
        }
        if (addProjectReqStatus?.length) {
            dispatch(addProjectRequestStatus(''))
        }
    }, [addProjectSuccess, addProjectError, addProjectReqStatus])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(countryListSuccess)) {
            setLoading(false)
        } else if (!isNull(countryListError)) {
            setLoading(false)
        }
    }, [countryListSuccess, countryListError])

    useEffect(() => {
        if (!isNull(stateListSuccess)) {
            setLoading(false)
        } else if (!isNull(stateListError)) {
            setLoading(false)
        }
    }, [stateListSuccess, stateListError])

    useEffect(() => {
        if (!isNull(cityListSuccess)) {
            setLoading(false)
        } else if (!isNull(cityListError)) {
            setLoading(false)
        }
    }, [cityListSuccess, cityListError])

    const handleCountrySelectChange = e => {
        setCountryDropdown(e);
        setCountryCode(e.iso2)
        setStateDropdown(null)
        setCityDropdown(null)
        fetchStateList(e.iso2)
    }

    const handleProjectAmountChoiceType = (type) => {
        if (type === 'FIXED') {
            setIsFixedAmount(true)
            setIsEstimatedAmount(false)
        } else if (type === 'ESTIMATED') {
            setIsEstimatedAmount(true)
            setIsFixedAmount(false)
        }
    }

    const handleAddTaxClick = () => {
        if (isEmpty(taxTypeLabel)) {
            displayErrorToast('Tax type cannot be blank')
        } else if (isEmpty(taxTypePercent)) {
            displayErrorToast('Tax percentage cannot be blank')
        } else {
            const currentList = taxInformation
            let taxAmount = 0
            if (!isEmpty(currentList)) {
                currentList.forEach(e => {
                    const percentage = parseFloat(amount) * (e.taxPercent) / 100
                    taxAmount = parseFloat(taxAmount) + parseFloat(percentage)
                })
            }
            const percentage = parseFloat(amount) * (taxTypePercent) / 100
            taxAmount = parseFloat(taxAmount) + parseFloat(percentage)
            let projectCost = parseFloat(amount) + parseFloat(taxAmount)
            if (isEstimatedAmount === true) {
                setEstimatedAmount(projectCost)
            }
            if (isFixedAmount === true) {
                setFinalAmount(projectCost)
            }
            currentList.push({
                taxType: taxTypeLabel,
                taxPercent: parseFloat(taxTypePercent)
            })
            setTaxInformation(currentList)
            setTaxTypeLabel('')
            setTaxTypePercent('')
        }
    }

    useEffect(() => {
        if (!isEmpty(amount) && parseFloat(amount) > 0) {
            if (!isEmpty(taxInformation)) {
                let taxAmount = 0
                taxInformation.forEach(e => {
                    const percentage = parseFloat(amount) * (e.taxPercent) / 100
                    taxAmount = parseFloat(taxAmount) + parseFloat(percentage)
                })
                let projectCost = parseFloat(amount) + parseFloat(taxAmount)
                if (isEstimatedAmount === true) {
                    setEstimatedAmount(projectCost)
                }
                if (isFixedAmount === true) {
                    setFinalAmount(projectCost)
                }
            } else {
                if (isEstimatedAmount === true) {
                    setEstimatedAmount(amount)
                }
                if (isFixedAmount === true) {
                    setFinalAmount(amount)
                }
            }
        }
    }, [amount])

    const handleImageChange = (e) => {
        if (!isEmpty(e.target.files)) {
            const files = e.target.files;
            const newSelectedFiles = Array.from(files);
            let currentImageList = imageList
            newSelectedFiles.forEach((file) => {
                currentImageList.push(file)
            });
            setImageList(currentImageList)
        }
    };

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Project name cannot be blank')
        } else if (isEmpty(startDate)) {
            displayErrorToast('Project start date not selected')
        } else if (isEmpty(endDate)) {
            displayErrorToast('Project end date not selected')
        } else if (isEmpty(selectedProjectStatus)) {
            displayErrorToast('Project status not selected')
        } else if (isEmpty(selectedProjectType)) {
            displayErrorToast('Project type not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else if (isEmpty(selectedCurrency)) {
            displayErrorToast('Project cost currency not selected')
        } else if (isFixedAmount === false && isEstimatedAmount === false) {
            displayErrorToast('Project cost type not selected')
        } else if (isEmpty(amount)) {
            displayErrorToast('Project amount cannot be blank')
        } else if (parseFloat(amount) < 0) {
            displayErrorToast('Invalid project amount')
        } else if (isEmpty(selectedCustomerType)) {
            displayErrorToast('Customer type not selected')
        } else if (selectedCustomerType.key === APP_CONSTANTS.CUSTOMER_TYPE.RESIDENTIAL && isEmpty(customerName)) {
            displayErrorToast('Customer name cannot be blank')
        } else if (selectedCustomerType.key === APP_CONSTANTS.CUSTOMER_TYPE.COMMERCIAL && isEmpty(customerBusinessName)) {
            displayErrorToast('Customer name cannot be blank')
        } else if (isEmpty(contactPersonName)) {
            displayErrorToast('Contact person name cannot be blank')
        } else if (isEmpty(contactPersonEmail) && isEmpty(contactPersonNumber)) {
            displayErrorToast('Both contact person email and number cannot be blank. Enter one of them.')
        } else if (isEmpty(address)) {
            displayErrorToast('Address cannot be blank')
        } else if (isEmpty(countryDropdown)) {
            displayErrorToast('Address country not selected')
        } else if (isEmpty(stateDropdown)) {
            displayErrorToast('Address state cannot be blank')
        } else if (isEmpty(cityDropdown)) {
            displayErrorToast('Address city cannot be blank')
        } else {
            setLoading(true)
            const fd = new FormData()
            fd.append('locationId', isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation)
            fd.append('businessId', isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness)
            fd.append('projectAuthorId', isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId)
            fd.append('projectAuthorType', user.data.userDetails.userType)
            fd.append('name', name)
            if (!isEmpty(description)) {
                fd.append('description', description)
            }
            fd.append('projectStatus', selectedProjectStatus.key)
            // if (isFixedAmount) {
            //     fd.append('isFixedAmount', amount)
            // }
            if (isEstimatedAmount) {
                fd.append('estimatedAmount', amount)
            }
            fd.append('isFixedAmount', isFixedAmount)
            fd.append('isEstimatedAmount', isEstimatedAmount)
            fd.append('currencyLabel', selectedCurrency.code)
            fd.append('currencySymbol', selectedCurrency.symbol)
            fd.append('currencyRegion', selectedCurrency.region)
            fd.append('amountBeforTax', amount)
            fd.append('finalAmount', finalAmount)
            if (!isEmpty(taxInformation)) {
                fd.append('taxInformation', JSON.stringify(taxInformation))
            }
            fd.append('customerType', selectedCustomerType.key)
            if (selectedCustomerType.key === APP_CONSTANTS.CUSTOMER_TYPE.RESIDENTIAL) {
                fd.append('customerName', customerName)
            }
            if (selectedCustomerType.key === APP_CONSTANTS.CUSTOMER_TYPE.COMMERCIAL) {
                fd.append('customerBusinessName', customerBusinessName)
            }
            fd.append('contactPersonName', contactPersonName)
            if (!isEmpty(contactPersonNumber)) {
                fd.append('contactPersonNumber', contactPersonNumber)
            }
            if (!isEmpty(contactPersonEmail)) {
                fd.append('contactPersonEmail', contactPersonEmail)
            }
            fd.append('projectType', selectedProjectType.key)
            fd.append('address', address)
            if (!isEmpty(addressLink)) {
                fd.append('addressLink', addressLink)
            }
            fd.append('country', countryDropdown.name)
            fd.append('countryCode', countryDropdown.iso2)
            fd.append('state', stateDropdown.name)
            fd.append('stateCode', stateDropdown.iso2)
            fd.append('city', cityDropdown.name)
            fd.append('startDate', moment(startDate).utc().format("YYYY-MM-DD hh:mm:ss A"))
            fd.append('endDate', moment(endDate).utc().format("YYYY-MM-DD hh:mm:ss A"))
            fd.append('isInvitationOpen', isInvitationOpen)
            if (imageList.length > 0) {
                imageList.forEach(element => {
                    fd.append('documents', element)
                })
            }
            dispatch(addProjectRequest(fd))
        }
    }

    const clearFields = () => {
        setName('')
        setDescription('')
        setStartDate(new Date())
        setEndDate(new Date())
        setIsFixedAmount(false)
        setIsEstimatedAmount(false)
        setAmount('')
        setTaxInformation([])
        setTaxTypeLabel('')
        setTaxTypePercent('')
        setEstimatedAmount('')
        setFinalAmount('')
        setSelectedCustomerType(null)
        setCustomerName('')
        setCustomerBusinessName('')
        setContactPersonName('')
        setContactPersonNumber('')
        setContactPersonEmail('')
        setAddress('')
        setAddressLink('')
        setSelectedCurrency(null)
        setIsInvitationOpen(false)
        setImageList([])
        if (fileInputRef.current) {
            fileInputRef.current.value = null
        }
        setShowSuccessModal(false)
    }

    const handleNewProjectAddClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Add Project' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new project' />
                    <FormFieldLabel className='up-bold-label' label='Project Details' />
                    <CommonInputFloatFull
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Project Name'
                        type='text'
                        value={name}
                    />
                    <CommonInputFloatFull
                        id='description'
                        onChange={e => setDescription(e.target.value)}
                        placeholder='Project Description'
                        type='text'
                        value={description}
                        multiline={true}
                        rows={5}
                    />
                    <CommonInputRow>
                        <div className="ap-date-container">
                            <FormFieldLabel label='Start Date' />
                            <DatePicker
                                className="ap-date-picker"
                                selected={startDate}
                                minDate={new Date()}
                                onChange={(date) => setStartDate(date)}
                            />
                        </div>
                        <div className="ap-date-container">
                            <FormFieldLabel label='End Date' />
                            <DatePicker
                                className="ap-date-picker"
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                minDate={startDate}
                            />
                        </div>
                    </CommonInputRow>
                    <FormFieldLabel label='Select Project Status' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedProjectStatus}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={projectStatus}
                        placeholder='Select Status'
                        onChange={e => setSelectedProjectStatus(e)} />
                    <FormFieldLabel label='Select Project Type' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedProjectType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={projectType}
                        placeholder='Select Type'
                        onChange={e => setSelectedProjectType(e)} />
                    <CommonCheckbox
                        id='invitationOpen'
                        label='Is project open for employee(s) assignment'
                        value={isInvitationOpen}
                        onChange={() => {
                            setIsInvitationOpen(!isInvitationOpen)
                        }}
                    />
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                        {!isEmpty(selectedBusiness) && <div>
                            <FormFieldLabel label='Select Business Location' />
                            {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedLocation}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e}
                                options={businessLocationListSuccess.data}
                                placeholder='Select Location'
                                onChange={e => setSelectedLocation(e)} />}
                            {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                        </div>}
                    </div>}
                    <FormFieldLabel className='up-bold-label' label='Cost Details' />
                    <FormFieldLabel label='Currency Information' />
                    {CurrencyLabel && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={selectedCurrency}
                        getOptionLabel={e => `${e.currency} (${e.symbol})`}
                        getOptionValue={e => e}
                        options={CurrencyLabel}
                        placeholder='Select Currency'
                        onChange={e => {
                            setSelectedCurrency(e)
                        }} />}
                    <FormFieldLabel label='Project Cost Type' />
                    <div className="ap-option-item-container mb-3">
                        <label className="ap-choice-label-container">
                            <input type='radio' value='FIXED' checked={isFixedAmount} onChange={e => handleProjectAmountChoiceType(e.target.value)} />
                            <span className="ap-choice-label">Fixed Amount</span>
                        </label>
                        <label className="ap-choice-label-container">
                            <input type='radio' value='ESTIMATED' checked={isEstimatedAmount} onChange={e => handleProjectAmountChoiceType(e.target.value)} />
                            <span className="ap-choice-label">Estimated Amount</span>
                        </label>
                    </div>
                    <CommonInputFloatFull
                        type='number'
                        id='amount'
                        onChange={e => setAmount(e.target.value)}
                        placeholder='Amount'
                        value={amount}
                    />
                    {!isEmpty(amount) && <div>
                        <FormFieldLabel label='Tax Information' />
                        <div className="ap-ti-parent-row-container">
                            <div className="ap-ti-input-container">
                                <CommonInputFloatHalf
                                    type='text'
                                    id='taxType'
                                    onChange={e => setTaxTypeLabel(e.target.value)}
                                    placeholder='Tax Type'
                                    value={taxTypeLabel}
                                />
                                <PercentInputHalf
                                    id='taxPercent'
                                    onChange={e => setTaxTypePercent(e.target.value)}
                                    placeholder='Tax Percentage'
                                    value={taxTypePercent}
                                />
                                {/* <CommonInputFloatHalf
                                    type='number'
                                    id='taxPercent'
                                    onChange={e => setTaxTypePercent(e.target.value)}
                                    placeholder='Tax Percent'
                                    value={taxTypePercent}
                                /> */}
                            </div>
                            <div className="ap-ti-button-label" onClick={() => handleAddTaxClick()}>Add</div>
                        </div>
                        {!isEmpty(taxInformation) && <div className="ap-ti-item-row-container">
                            {taxInformation.map(e => (<div className="ap-ti-item-container">
                                {e.taxType} - {e.taxPercent} %
                            </div>))}
                        </div>}
                    </div>}

                    {!isEmpty(amount) && isEstimatedAmount === true && <CommonInputFloatFull
                        id='estimateAmount'
                        onChange={e => setEstimatedAmount(e.target.value)}
                        placeholder='Estimated Amount'
                        type='number'
                        value={estimatedAmount}
                        isDisable={true}
                    />}
                    {!isEmpty(amount) && isFixedAmount === true && <CommonInputFloatFull
                        id='fixedAmount'
                        onChange={e => setFinalAmount(e.target.value)}
                        placeholder='Final Amount'
                        type='number'
                        value={finalAmount}
                        isDisable={true}
                    />}
                    <FormFieldLabel className='up-bold-label' label='Customer Details' />
                    <FormFieldLabel label='Select Customer Type' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedCustomerType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={customerType}
                        placeholder='Select Customer Type'
                        onChange={e => setSelectedCustomerType(e)} />
                    {!isEmpty(selectedCustomerType) && selectedCustomerType.key === APP_CONSTANTS.CUSTOMER_TYPE.COMMERCIAL && <CommonInputFloatFull
                        type='text'
                        id='customerBusinessName'
                        onChange={e => setCustomerBusinessName(e.target.value)}
                        placeholder='Customer Business Name'
                        value={customerBusinessName}
                    />}
                    {!isEmpty(selectedCustomerType) && selectedCustomerType.key === APP_CONSTANTS.CUSTOMER_TYPE.RESIDENTIAL && <CommonInputFloatFull
                        type='text'
                        id='customerName'
                        onChange={e => setCustomerName(e.target.value)}
                        placeholder='Customer Name'
                        value={customerName}
                    />}
                    <CommonInputFloatFull
                        type='text'
                        id='contactPersonName'
                        onChange={e => setContactPersonName(e.target.value)}
                        placeholder='Contact Person Name'
                        value={contactPersonName}
                    />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='text'
                            id='contactPersonNumber'
                            onChange={e => setContactPersonNumber(e.target.value)}
                            placeholder='Contact Number'
                            value={contactPersonNumber}
                        />
                        <CommonInputFloatHalf
                            type='text'
                            id='contactPersonEmail'
                            onChange={e => setContactPersonEmail(e.target.value)}
                            placeholder='Contact Email'
                            value={contactPersonEmail}
                        />
                    </CommonInputRow>
                    <FormFieldLabel label='Project Location Details' />
                    <div className="ap-disclaimer-label"><span className="ap-disclaimer-label-bold">Note:</span>For on-site jobs, enter the work location address (used for invoicing, if required). For remote jobs, enter the address where the invoice should be sent.</div>
                    <CommonInputFloatFull
                        type="name"
                        id="address"
                        placeholder="Address"
                        value={address}
                        onChange={e => setAddress(e.target.value)}
                        subText='Enter street address'
                        isSubtext={true}
                    />
                    <CommonInputFloatFull
                        type="name"
                        id="addressLink"
                        placeholder="Address Link"
                        value={addressLink}
                        onChange={e => setAddressLink(e.target.value)}
                        subText='Google map link if on-site work otherwise remote job link if available'
                        isSubtext={true}
                    />
                    {countryListSuccess && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={countryDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={countryListSuccess}
                        placeholder='Select Country'
                        onChange={e => {
                            handleCountrySelectChange(e)
                        }} />}
                    <CommonInputRow>
                        {stateListSuccess && <Select
                            menuPlacement="auto"
                            className='select-half-width up-select-margin'
                            value={stateDropdown}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={stateListSuccess}
                            placeholder='Select State'
                            onChange={e => {
                                setStateDropdown(e);
                                setCityDropdown(null)
                                fetchCityList(countryCode, e.iso2)
                            }} />}
                        {cityListSuccess && <Select
                            menuPlacement="auto"
                            className='select-half-width up-select-margin'
                            value={cityDropdown}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={cityListSuccess}
                            placeholder='Select City'
                            onChange={e => {
                                setCityDropdown(e);
                            }} />}
                    </CommonInputRow>
                    <FormFieldLabel className='up-bold-label' label='Additional Details' />
                    <FormFieldLabel label='Attach one or more documents at once' />
                    <div className="input-group margin-bottom-10">
                        <input type="file" multiple ref={fileInputRef} className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload Image" onChange={handleImageChange} />
                    </div>
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{addProjectSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add another project?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleNewProjectAddClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddProject